import React from 'react';
import { Calendar } from 'lucide-react';
import { ExperienceSectionProps } from '@/types';

const ExperienceSection: React.FC<ExperienceSectionProps> = ({ experiences }) => {
  return (
    <section id="experience" className="py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent">
            Professional Experience
          </h2>
          <p className="text-xl text-gray-300">
            Leading infrastructure initiatives at innovative technology companies
          </p>
        </div>

        <div className="space-y-12">
          {experiences.map((exp, index) => (
            <div key={index} className="bg-gray-800/50 p-8 rounded-2xl border border-gray-700 hover:border-blue-500/30 transition-all duration-300">
              <div className="flex flex-col lg:flex-row lg:justify-between lg:items-start mb-6">
                <div>
                  <h3 className="text-2xl font-bold text-blue-400 mb-2">{exp.role}</h3>
                  <h4 className="text-xl text-white mb-2">{exp.company}</h4>
                  <div className="text-gray-400">{exp.location}</div>
                </div>
                <div className="flex items-center gap-2 text-gray-300 mt-4 lg:mt-0">
                  <Calendar className="w-5 h-5 text-blue-400" />
                  {exp.period}
                </div>
              </div>

              <ul className="space-y-3">
                {exp.highlights.map((highlight, idx) => (
                  <li key={idx} className="flex items-start gap-3 text-gray-300">
                    <div className="w-2 h-2 bg-blue-400 rounded-full mt-2 flex-shrink-0"></div>
                    {highlight}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;